<template lang="html">
    <b-modal v-model="showDataToSendModal" title="Data To Send"  @hide=" $emit('update:is-show', false)" hide-footer>
      <div>
        All data will send via sub4 in Affise tracking link, make sure to add {sub4} to the link
      </div>
    </b-modal> 
</template>
<script>
    
export default {
    
    props: ['isShow'],
    data() {
        return {

        }
    },
    created(){

    },
    computed: {
        showDataToSendModal: {
            get: function() {
                return this.isShow
            },
            set: function() {

            }
        }
    },
    methods: {

    },    
}
</script>
<style scoped>

</style>